// Dependencies
import styled from 'styled-components';

// Images
import tick from '../../../img/icons/forms/tick.svg';

const InputFactoryStyles = styled.div`
  width: 100%;

  input,
  textarea,
  select {
    width: 100%;
    font-size: 0.938rem;
    font-weight: var(--font-weight-regular);
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: var(--color-bark);

    &:focus {
      outline: none;
    }
  }

  input,
  textarea {
    ${(props) => props?.error && 'border-color: var(--color-error);'}
  }

  input {
    padding: 0.3rem 0;
    border-bottom: 0.063rem solid #505b68;
    background-color: transparent;
    transition:
      color 0.4s,
      border-color 0.4s;

    &::placeholder {
      color: var(--color-bark);
      transition: color 0.4s;
    }

    &.checkbox {
      width: auto;
      margin: 0 auto 0 0;
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked ~ .styled-checkbox {
        background-image: url(${tick});
        background-position: center;
        background-size: 0.7rem;
      }
    }

    &.error {
      border-color: var(--color-error);
      color: var(--color-error);

      &::placeholder {
        color: var(--color-error);
      }
    }
  }

  select,
  textarea,
  .dropzone-wrapper {
    border: 0.063rem solid #505b68;
  }

  select {
    font-weight: var(--font-weight-regular);
  }

  textarea {
    min-height: 12.5rem;
    padding: 0.625rem;
    resize: none;
  }

  .react-select-wrapper {
    position: relative;
    z-index: 10;
    min-width: 12rem;
    cursor: pointer;
  }

  .react-select {
    font-weight: var(--font-weight-regular);

    &__placeholder,
    &__single-value,
    &__option,
    &__input-container,
    &__menu {
      font-weight: var(--font-weight-regular);
      color: var(--color-bark);
    }

    &__control {
      background-color: transparent;
      cursor: pointer;
      border-radius: 0;
      border: 0.063rem solid #505b68;
      box-shadow: none;

      &:hover {
        border: 0.063rem solid #505b68;
      }
    }

    &__option {
      &:hover {
        background-color: var(--color-sand);
      }

      &--is-focused {
        color: #000;
        background-color: var(--color-sand);
      }

      &--is-selected {
        color: #000;
        background-color: var(--color-bark);

        &:hover {
          background-color: var(--color-bark);
        }
      }
    }

    &__menu {
      border-radius: 0;
    }
  }

  .dropzone-wrapper {
    padding: 1.5rem 0.75rem;
    font-weight: var(--font-weight-medium);

    .dropzone {
      padding: 1rem 0;
      text-align: center;

      &.files {
        padding: 0 1rem 1.5rem;
      }
    }

    .previews {
      padding: 1rem 0.5rem 0 0.5rem;

      .preview-block {
        position: relative;
        width: 100%;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1rem;
        padding: 0.5rem 1rem;
        line-height: 1;
        border: 0.063rem solid var(--color-charcoal);
        object-fit: cover;
        background-color: #f8f8f8;
      }

      .preview-image {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: cover;
        border: 0.063rem solid var(--color-charcoal);
      }

      .file-name {
        height: 1rem;
        max-width: 5rem;
        font-size: 0.8rem;
        line-height: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .remove-file {
        display: flex;
        align-items: center;
        padding: 0.4rem 0.6rem;
        font-size: 0.8rem;
        font-weight: var(--font-weight-medium);
        line-height: 0;
        text-transform: uppercase;
        background-color: var(--color-beige);

        .icon {
          width: 1.1rem;
          height: 1.1rem;
          margin-left: 0.2rem;
        }
      }
    }
  }

  .icon-wrap {
    position: relative;
    width: 100%;

    input {
      padding-right: 2rem;
    }

    .icon-btn {
      position: absolute;
      top: 0.36rem;
      right: 0.4rem;
      .icon {
        width: 1.1rem;
      }
    }
  }

  .styled-checkbox {
    position: absolute;
    left: 0;
    top: 0.8rem;
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    margin-top: -0.6rem;
    border: 0.063rem solid var(--color-charcoal);
  }

  label {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    font-weight: var(--font-weight-medium);
    cursor: pointer;

    input,
    select,
    textarea,
    .react-select-wrapper,
    .dropzone-wrapper {
      margin: 0.2rem 0 0;
    }

    &.checkbox {
      position: relative;
      display: inline;
      padding: 0 0 0 1.6rem;
    }

    .checkbox {
      margin: 0.5rem auto 0 0;
    }
  }

  .instructions {
    margin-top: 0.25rem;
    font-size: 0.8rem;
    opacity: 0.7;
  }

  .error {
    margin: 0.2rem 0 0;
    color: var(--color-error);
  }

  .form-error {
    margin: 3rem 0 0;
  }

  @media (min-width: 500px) {
    .dropzone-wrapper {
      .previews {
        .preview-block {
          justify-content: normal;
        }

        .preview-image {
          margin-right: 1rem;
        }

        .file-name {
          font-size: 0.8rem;
          max-width: 10rem;
        }

        .remove-file {
          margin-left: auto;
        }
      }
    }
  }

  @media (min-width: 768px) {
    input,
    textarea,
    select {
      font-size: 1.125rem;
    }

    .dropzone-wrapper {
      .previews {
        padding: 1rem 1rem 0 1rem;

        .preview-block {
          height: 4.5rem;
        }

        .file-name {
          max-width: 8rem;
        }

        .preview-image {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .dropzone-wrapper .previews .file-name {
      max-width: 15rem;
    }
  }

  @media (min-width: 1920px) {
    .dropzone-wrapper .previews .file-name {
      max-width: 20rem;
    }
  }
`;

export default InputFactoryStyles;
